module.exports = __webpack_public_path__ + "static/img/product_img_03.8440e26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_img_03.jpg
// module id = i55N
// module chunks = 0